import React from 'react'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import "../styles/Experience.css";

const Experience = () => {
  return (
    <div className='experience'>
      <VerticalTimeline lineColor='#21325e'>
      <VerticalTimelineElement
          className='vertical-timeline-element--education'
          date="2023 - 2024"
          icon={<WorkIcon />}
          iconStyle={{ background: "orange", color: "#fff" }}
        >
          <h3 className="vertical-timeline-element-title">
            ewo
          </h3>
          <h4 className="vertical-timeline_element-subtitle">
            Software Engineer 
          </h4>
          <p>Developed and maintained testing tools for smart lamps, designed user-centric React interfaces, expanded APIs, and built microservices for optimized device interoperability and system efficiency.</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className='vertical-timeline-element--education'
          date="2019 - 2023"
          icon={<SchoolIcon />}
          iconStyle={{ background: "#3e497a", color: "#fff" }}
        >
          <h3 className="vertical-timeline-element-title">
            Free University of Bozen-Bolzano
          </h3>
          <p>
            Bachelor's Degree, Computer Science
          </p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className='vertical-timeline-element--education'
          date="2022 - 2023"
          icon={<WorkIcon />}
          iconStyle={{ background: "orange", color: "#fff" }}
        >
          <h3 className="vertical-timeline-element-title">
            ewo
          </h3>
          <h4 className="vertical-timeline_element-subtitle">
            Software Engineer Intern
          </h4>
          <p>Developed a web app that streamlined smart light testing by 80%, enhanced quality control, and integrated APIs, validated in real-world tests in Germany.</p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </div>
  )
}

export default Experience